import React, { useEffect } from 'react';
import { useAuthContext } from 'src/context/AuthContext';
import { useHarvestingContext } from 'src/views/harvesting/harvesting-context';
const ForceReset = () => {
  const { resetBaskets } = useHarvestingContext();
  const { logout } = useAuthContext();
  useEffect(() => {
    resetBaskets();
    localStorage.clear();
    logout();
  }, []);

  return <>loading....</>;
};

export default ForceReset;
